/*
 * @Author: wangheng 1678476311@qq.com
 * @Date: 2022-07-15 11:23:37
 * @LastEditors: wangheng 1678476311@qq.com
 * @LastEditTime: 2022-08-03 15:08:51
 * @FilePath: \saas-plat-manage-vue\src\main.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import zhLocale from "element-plus/lib/locale/lang/zh-cn";
import "dayjs/locale/zh-cn";
import locale from "element-plus/lib/locale/lang/zh-cn"; //中文
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import Globalcontentarea from "./components/Globalcontentarea/index.vue";
import Redprompt from "./components/Bannerlogo/Redprompt.vue";
import Layout from "@/views/layout/index.vue";
import GoogleDialogue from "@/components/dialog/GoogleDialogue.vue";
import Pageheader from "@/components/Pageheader/index.vue";
import Publicform from "@/components/form/index.vue";
import Moduletitle from "@/components/Globalcontentarea/Moduletitle.vue";
import uploadb from "@/components/uploadb/index.vue";
import MyTable from "@/components/MyTable/index.vue";
import MyUpload from "@/components/MyUpload/index.vue";
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
// tabs切换
import Tabs from "@/components/Tabs/index.vue";
const app = createApp(App);
app.component("Globalcontentarea", Globalcontentarea); //页面头不分离
app.component("Redprompt", Redprompt);
app.component("Tabs", Tabs);
app.component("GoogleDialogue", GoogleDialogue);
app.component("Pageheader", Pageheader); //页面头部 单独分离 胶囊状
app.component("Publicform", Publicform); //biange
app.component("Moduletitle", Moduletitle);
app.component("uploadb", uploadb);
app.component("MyTable", MyTable);
app.component("MyUpload", MyUpload);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(store).use(router).use(ElementPlus, { locale }).mount("#app");
// router.beforeEach((to, form, next) => {
//   const asyncRouterMap = JSON.parse(sessionStorage.getItem("asyncRouterMap") as string);
//   console.log(asyncRouterMap);
//   if (asyncRouterMap) {
//     asyncRouterMap.forEach((item: any) => {
//       item.component = () => Layout;
//     });
//     // 默认路由
//     const currenRoutes = router.options.routes;
//     // 动态路由添加
//     asyncRouterMap.forEach((item: any) => {
//       // has用于判断当前路由中是否已经具有，避免重复
//       const has = currenRoutes.some((it) => it.path == item.path);
//       if (!has) {
//         currenRoutes.push(item);
//       }
//     });
//     currenRoutes.forEach((item) => {
//       if (item.children) {
//         item.children.forEach((item2) => {
//           item2.component = () => import(`@/views${item2.path}`);
//           router.addRoute(item2);
//         });
//       }
//       router.addRoute(item);
//     });
//     store.commit("SET_USER_ROUTER", currenRoutes);
//     store.commit("ASYNC_ROUTER_MARK", true);
//     console.log(store.state.routerArr);
//   }
//   next();
// });
